<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex;margin-top: 10px;">
              <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <!--
                  <span style="user-select: none">
                    <a-tree
                      class="my-area-select-tree"
                      @select="onSelect"     
                      :selectedKeys="selectedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                    </a-tree>
                  </span>
                  -->
                  <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    @node-click="nodeClick"
                    ref="areaTree">
                  </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="12" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('查询起止时间')">
                      <a-range-picker
                        v-model="date"
                        :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                        format="YYYY-MM-DD"
                        @change="onDateRangeChange"
                        @ok="onOk"
                      />
                  </a-form-item>
                </a-col>
              <!-- <template v-if="toggleSearchStatus">
              </template> -->
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div> 
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls($t('上报分析'))">{{ $t('导出') }}</a-button>
        </div> 
        <div class="table-fixed">
          <a-table
            ref="table"
            size="middle"
            tableLayout="fixed"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            </span>
          </a-table>
        </div>
        <meter-up-counts-modal ref="modalForm" @ok="modalFormOk"></meter-up-counts-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUpCountsModal from './modules/MeterUpCountsModal'
  import { getAction } from '@/api/manage'
  import moment from 'moment'
  export default {
    name: 'MeterUpCountsList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin],
    components: {
      MeterUpCountsModal,
    },
    data () {
      return {
        description: 'meter_up_data_analysis管理页面',
        collapsed: false,
        tabs:'',
        DayPieData:[ ],
        date:[],
        url: {
          list: "/jeecg-charge/meter/meterUpDataAnalysis/getMeterUpCounts",
          delete: "/jeecg-charge/meter/meterUpDataAnalysis/delete",
          deleteBatch: "/jeecg-charge/meter/meterUpDataAnalysis/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUpDataAnalysis/countExportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meterUpDataAnalysis/importExcel",
        },
        dictOptions:{},
        dateType: 2
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：图例使用 computed 以响应语言切换
      DayPieFields () {
        return ['昨日', '今日'].map(item => this.$t(item))
      },
      // i18n：表头使用 computed 以响应语言切换
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表安装地址'),
            align:"center",
            dataIndex: 'userAddr',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户手机'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            customRender: (t, r, index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width: 150,
            ellipsis: true
          },{
            title: this.$t('定时上传'),
            align:"center",
            dataIndex: 'upWay0MeterCount',
            width:100,
            ellipsis: true
          },{
            title: this.$t('上电上传'),
            align:"center",
            dataIndex: 'upWay1MeterCount',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('手动上传'),
            align:"center",
            dataIndex: 'upWay2MeterCount',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('故障上传'),
            align:"center",
            dataIndex: 'upWay3MeterCount',
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('阀门动作上传'),
            align:"center",
            dataIndex: 'upWay4MeterCount',
            width:100,
            ellipsis: true
          },
          // {
          //   title: '操作',
          //   dataIndex: 'action',
          //   align:"center",
          //   fixed:"right",
          //   width:100,
          //   scopedSlots: { customRender: 'action' }
          // }
        ]
      },
    },
    methods: {
      onOk(value) {
        console.log('onOk:', value);
      },
    }
  }
</script>
<style scoped>
  .tables{
    width: 88%;
  }
  .fontsize{
    font-size:20px
  }
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>